var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseBrick',{attrs:{"scale":_vm.scale,"ch":_vm.ch,"class-name":'block-brick',"cw":_vm.cw,"l1x":_vm.l1x,"l1y":_vm.l1y,"l2x":_vm.l2x,"l2y":_vm.l2y,"step":_vm.step,"tx":_vm.tx,"ty":_vm.ty,"x":_vm.x,"y":_vm.y,"vl":_vm.vl}})}
var staticRenderFns = []

export { render, staticRenderFns }